export function createCellCheckbox() {
  return {
    name: 'KyeVirtualTableCellCheckbox',
    props: {
      isAllSelected: Boolean,
      UPDATE_checkbox: Object,
      selectable: Function,
      rowData: Object,
      rowIndex: Number,
      rowSelectedChanged: Function,
      getSelection: Function,
      uniqueId: String | Number
    },
    data() {
      return {
        value: false,
        isSelecting: false
      }
    },
    watch: {
      isAllSelected: {
        handler() {
          this.changeSelected()
        },
        immediate: true
      },
      UPDATE_checkbox: {
        handler() {
          this.changeSelected()
        },
        deep: true
      }
    },
    render() {
      const disabled = this.selectable ? !this.selectable.call(null, this.rowData, this.rowIndex) : false
      return (
        <el-checkbox
          ref="checkbox"
          nativeOn-click={event => event.stopPropagation()}
          nativeOn-dblclick={event => event.stopPropagation()}
          value={this.value}
          disabled={disabled}
          on-change={this.change}
        />
      )
    },
    methods: {
      change(val) {
        this.rowSelectedChanged(val, this.rowData, this.rowIndex, true)
        this.changeSelected()
      },
      changeSelected() {
        const checkSelect = () => {
          const uniqueId = this.uniqueId
          const selection = this.getSelection()
          this.value = selection.has(uniqueId)
        }

        if (!this.isAllSelected) {
          checkSelect()
        } else {
          this.value = this.isAllSelected
        }

        // 特写给禁用需要勾选的视觉交互
        const disabled = this.selectable ? !this.selectable.call(null, this.rowData, this.rowIndex) : false
        if (disabled) {
          checkSelect()
        }
      },
      handleMousemove() {
        this.change(!this.value)
      },
      getCheckBoxCellEl() {
        return this.$el.parentNode && this.$el.parentNode.parentNode
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/feature/checkbox/index.js